import { DCUIContent, DCUITheme } from "@iddataweb/idw-common-ui/types";
import { resources } from "@constants/hardcoded-strings";
import { TabTitleWithErrorCount } from "@containers/common/tab-title-with-error-count/tab-title-with-error-count";
import { ErrorAlert } from "@containers/common/error-alert/error-alert";
import { DCUIThemingThemeValidationErrors } from "@idw-types/common/validation/common/dcui-theming-validation-errors";

export const getDCUIThemingThemeValidationErrors = (
    isUsingDCUIVersion2: boolean,
    hasDisplayableDocumentCaptureAttributes: boolean,
    dcuiContent: DCUIContent,
    dcuiTheme: DCUITheme
): DCUIThemingThemeValidationErrors => {
    let count = 0;
    let headerLogoError = null;
    let headerTextError = null;
    if (isUsingDCUIVersion2 && hasDisplayableDocumentCaptureAttributes) {
        if (dcuiTheme.header.showLogo && !dcuiTheme.header.logoUrl) {
            count += 1;
            headerLogoError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
        if (dcuiTheme.header.showText && !dcuiContent.header.text) {
            count += 1;
            headerTextError = <ErrorAlert><span>{resources.common.requiredField}</span></ErrorAlert >;
        }
    }

    return {
        headerLogoError,
        headerTextError,
        count: count,
        tabTitle: <TabTitleWithErrorCount
            tabName={resources.pages.verificationServiceDetails.tabs.dcuiTheming.subTabs.theme.tabName}
            errorCount={count}
        />
    };
};